import { useEffect } from "react";
import DothanHeroSection from "./components/HeroSection";
import DothanStickyNav from "./components/StickyNav";
import DothanProcessingTimeSection from "./components/ProcessingTimeSection";
import DothanServicesSection from "./components/ServicesSection";
import DothanLocalAreaSection from "./components/LocalAreaSection";
import DothanTravelTimingSection from "./components/TravelTimingSection";
import DothanDestinationsSection from "./components/DestinationsSection";
import DothanTestimonialsSection from "./components/TestimonialsSection";
import DothanAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DothanComparisonSection from "./components/ComparisonSection";
import DothanMistakesSection from "./components/MistakesSection";
import DothanHowItWorksSection from "./components/HowItWorksSection";
import DothanFAQSection, { faqs } from "./components/FAQSection";
import DothanHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DothanFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function DothanPage() {
  useEffect(() => {
    document.title = "Emergency Passport Dothan AL — Expedited Same-Day Service | Fast Passport Center";
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };
    const pageUrl = "https://fastpassportcenter.com/dothan/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Dothan, AL — as fast as 24 hours. Serving Fort Novosel military families, Wiregrass agribusiness, and mission travelers. A+ BBB rated, registered State Dept. courier.");
    setMeta("geo.placename", "Dothan, Alabama");
    setMeta("geo.region", "US-AL");
    setMeta("geo.position", "31.2232;-85.3905");
    setMeta("ICBM", "31.2232, -85.3905");
    const graph = [
      { "@type": "BreadcrumbList", itemListElement: [{ "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" }, { "@type": "ListItem", position: 2, name: "Alabama", item: "https://fastpassportcenter.com/alabama/" }, { "@type": "ListItem", position: 3, name: "Dothan Passport Services", item: pageUrl }] },
      { "@type": "LocalBusiness", name: "Fast Passport Center", description: "Emergency and expedited passport services for Dothan, Wiregrass, and Houston County, Alabama — as fast as 24 hours.", url: pageUrl, telephone: "+1-877-253-0084", areaServed: { "@type": "City", name: "Dothan", containedInPlace: { "@type": "State", name: "Alabama" } }, priceRange: "$$$", openingHours: ["Mo-Fr 09:00-18:00"], aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" } },
      { "@type": "FAQPage", mainEntity: faqs.map((faq) => ({ "@type": "Question", name: faq.q, acceptedAnswer: { "@type": "Answer", text: faq.a } })) },
    ];
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-dothan";
    document.getElementById("structured-data-dothan")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);
    return () => { document.getElementById("structured-data-dothan")?.remove(); const canonical = document.querySelector('link[rel="canonical"]'); if (canonical) canonical.remove(); };
  }, []);

  return (
    <div className="font-sans">
      <DothanHeroSection />
      <DothanStickyNav />
      <DothanProcessingTimeSection />
      <DothanServicesSection />
      <DothanLocalAreaSection />
      <DothanTravelTimingSection />
      <DothanDestinationsSection />
      <DothanTestimonialsSection />
      <DothanAcceptanceFacilitiesSection />
      <DothanComparisonSection />
      <DothanMistakesSection />
      <DothanHowItWorksSection />
      <DothanFAQSection />
      <DothanHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/dothan" state="AL" />
      <DothanFinalCTA />
    </div>
  );
}